import React, {FC} from "react";
import cls from "../../posts/posts.module.scss"
import {IPostData} from "../../../types/posts";
import {TranslationsType} from "../../../types/homePageTypes";
import PostCard from "../../posts/PostCard";
import animCls from "../builder.module.scss"

interface IProps {
    item: {
        customClassNames: string;
        buttonValue: string;
        settings: [];
        blog: {
            blogs: Array<any>,
            category: {
                id: number,
                slug: string
            },
            quantity: number
        };
        linkValueButton: {
            id: string;
            value: string;
            checked: boolean
        }
        postComponentInfo: Array<any>;
        qtyPerRow: number;
        date_checked: boolean;
        read_more_checked: boolean;
        convertedSettings: {
            animationAos: { "data-aos": any },
            styles: any;
            parentStyles: any
        }
        hoverAnimation: string
    }
    translationsData: TranslationsType;
}


const PostsComponent: FC<IProps> = (
    {
        item: {
            customClassNames,
            postComponentInfo: renderedPosts = [],
            qtyPerRow,
            date_checked,
            read_more_checked,
            convertedSettings: {
                styles,
                animationAos: {"data-aos": dataAos = null} = {},
            } = {},
            hoverAnimation
        },
        translationsData
    }
) => {
    const postsList = renderedPosts?.map((post: IPostData) => {
        return <div key={post.id} className={cls.post_list_item}>
            <PostCard
                post={post}
                category={post.default_category}
                translationsData={translationsData}
                date_checked={date_checked}
                read_more_checked={read_more_checked}
            />
        </div>
    });

    const viewPosts = {true: postsList, false: ""}

    return <div
        className={`
            ${cls.posts_list}
            ${customClassNames}
            ${animCls[hoverAnimation ?? "none"]}
            ${cls[`posts_list_row_${qtyPerRow}`]}
        `}
        data-aos={dataAos}
        style={{margin: styles?.margin, padding: styles?.padding}}
    >
        {viewPosts[`${!!postsList?.length}`]}
    </div>
};

export default PostsComponent;